module.exports = __webpack_public_path__ + "img/pasture_cynodon_middle.d5a552f0.jpg";